import React from "react";
import { getExcelVersion } from "../../util/versioning";
import Page from "../components/container/Page";
import { AppRoutes } from "../../routes/AppRouter";

export default function AboutPage() {
  const version = getExcelVersion();

  return (
    <Page title="MFA Add-In v.2.1.0" subtitle={AppRoutes.About.Subtitle}>
      <div className="d-flex flex-column p-4 gap-5" style={{ overflowY: "auto" }} >
        <div className="d-flex flex-column gap-4">
          <div className="d-flex flex-column">
            <a href="https://mfaunderwriting.com/mfa_product_support" style={{ color: "black" }} target="_blank" rel="noopener noreferrer" className="text-decoration-none ">
              <h5 className="text-uppercase m-0"><strong>NEED HELP?</strong></h5>
              <span className="text-decoration-underline">Reach out now</span>
            </a>
          </div>

          <div className="d-flex flex-column">
            <h5 className="text-uppercase m-0"><strong>A service by</strong></h5>
            <span><a href="https://mfaunderwriting.com" style={{ color: "black" }} target="_blank" rel="noopener noreferrer">MFA Underwriting</a></span>
          </div>
          <div className="d-flex flex-column gap-0">
            <h6 className="text-uppercase m-0"><strong>Made with ❤️</strong></h6>
            <span>by <a href="https://jumoca.de" style={{ color: "black" }} target="_blank" rel="noopener noreferrer">Julian Caspary</a></span>
          </div>
        </div>
        {
          version && (
            <div className="d-flex flex-column gap-2">
              <h6 className="text-uppercase"><strong>System Information</strong>
              </h6>
              <div className="d-flex flex-column">
                <strong>Host</strong>
                <span>{version.host}</span>
              </div>
              {
                version.platform && (
                  <div className="d-flex flex-column">
                    <strong>Platform</strong>
                    <span>{version.platform}</span>
                  </div>
                )
              }
              <div className="d-flex flex-column">
                <strong>Desktop</strong>
                <span>{version.isDesktop ? "Yes" : "No"}</span>
              </div>
              <div className="d-flex flex-column">
                <strong>Host Version</strong>
                <span>{version.majorVersion}.{version.minorVersion}.{version.build}.{version.revision}</span>
              </div>
              {version.isLocalhost && <em>Local development</em>}
            </div>
          )
        }

      </div>
    </Page>
  )
}